import React from 'react'
import { AccountDetails } from '../../../types'
import { StandardDl } from './StandardDl'

export const CdTermDl: React.FC<{ account: AccountDetails }> = ({ account }) =>
  account.cdTermDescription ? (
    <StandardDl title="CD Term:" definition={account.cdTermDescription} />
  ) : null
